import React from 'react';
import { Controller } from 'react-hook-form';
import { Box, TextField, Typography, Autocomplete, FormHelperText } from '@mui/material';

export default function CustomSelect({
  name,
  label,
  control,
  errors,
  options = [], // array of { label, value }
  isRequired = false,
  placeholder = 'Select...',
  onChange: externalOnChange,
  disabled = false,
  isMultipleError = false,
  ...rest
}) {
  return (
    <Box>
      {label && (
        <Typography variant="h6" className="formLabel">
          {label} {isRequired && <span style={{ color: 'red' }}>*</span>}
        </Typography>
      )}

      <Controller
        name={name}
        control={control}
        rules={{
          required: isRequired ? `${label || name} is required` : false,
          validate: (value) => {
            if (isRequired && (!value || value === '' || value === ' ')) {
              return `Please select a valid ${label || name}`;
            }
            return true;
          }
        }}
        render={({ field: { onChange, value, ref } }) => (
          <Autocomplete
            options={options || []}
            getOptionLabel={(option) => option?.label || ''}
            value={
              options.find((opt) => String(opt.value) === String(value)) ||
              // if stored value is already the option object
              (value && value.label && value.value ? value : null)
            }
            // onChange={(_, newValue) => onChange(newValue ? newValue.value : '')}
            onChange={(event, newValue, reason, details) => {
              const val = newValue ? newValue.value : '';
              onChange(val);
              if (externalOnChange) externalOnChange(event, val, newValue, reason, details);
            }}
            isOptionEqualToValue={(option, val) => {
              // val might be the option object or a primitive id/value
              const valValue = val && typeof val === 'object' ? val.value : val;
              return String(option.value) === String(valValue);
            }}
            disabled={disabled}
            renderInput={(params) => {
              let fieldError;
              if (isMultipleError) {
                const fieldKey = name.split('.').pop();
                fieldError = errors?.[fieldKey];
              } else {
                fieldError = errors?.[name];
              }

              return (
                <TextField
                  {...params}
                  inputRef={ref}
                  placeholder={placeholder}
                  // error={!!errors?.[name]}
                  // helperText={errors?.[name]?.message}
                  error={!!fieldError}
                  helperText={fieldError?.message}
                  variant="outlined"
                  size="small"
                  {...rest}
                />
              );
            }}
          />
        )}
      />
    </Box>
  );
}
